import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const Wrapper = styled(Box)(props => `
    display:flex;
    width:100%;

    & .accordionWrapper {width:100%;}

    & .formCheckbox {
        width: 250px;
        display: block;
        margin: 0;
    }
    & .formCheckbox .MuiCheckbox-root {
        padding: 0;
        margin-left: -4px;
    }
    & .formCheckbox .MuiFormControlLabel-label {
        font-weight: 400 !important;
        font-size: 14px !important;
        line-height: 23px !important;
        padding-left: 10px;
    }
`)

export const CheckBoxWrapper = styled(Box)(props => `
    width:100%;
    display:flex;
    flex-wrap:wrap;
`)
